












































import { Component, Vue } from "vue-property-decorator"
import CandidateRegisterAccountDetails from "./CandidateRegisterAccountDetails.vue"
import CandidateRegisterSecurityCode from "./CandidateRegisterSecurityCode.vue"
import CandidateRegisterReset from "./CandidateRegisterReset.vue"
@Component({
  components: {
    CandidateRegisterAccountDetails,
    CandidateRegisterSecurityCode,
    CandidateRegisterReset,
  },
})
export default class CandidateRegisterStepper extends Vue {
  step = '01'

  beforeDestroy() {
    this.$store.commit("Auth/CLEAR_GUEST_STATE")
  }
}
